if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          form: this.querySelector('form'),
          select: this.querySelector('select'),
        };
        this.addEventListener('change', this.onOptionChange);
      }

      onOptionChange() {
        if (this.elements.form) this.elements.form.submit();
      }
    }
  );
}

if (!customElements.get('localization-listbox')) {
  customElements.define(
    'localization-listbox',
    class LocalizationListbox extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          form: this.querySelector('form'),
          inputs: this.querySelectorAll('input[name="locale_code"], input[name="country_code"]'),
          items: this.querySelectorAll('a'),
        };
        Array.from(this.elements.items).forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      onItemClick(event) {
        event.preventDefault();

        Array.from(this.elements.inputs).forEach((input) => input.value = event.currentTarget.dataset.value);
        if (this.elements.form) this.elements.form.submit();
      }
    }
  );
}